import { type FC } from "react";

import { css } from "@emotion/css";
import { Spinner } from "@snapchat/snap-design-system";

import { PageContent } from "./PageContent";

interface PageContentSpinner {
    height?: string;
}

export const PageContentSpinner: FC<PageContentSpinner> = ({ height }) => {
    return (
        <PageContent
            className={css`
                align-items: center;
                justify-content: center;
                height: ${height ?? "calc(100vh - 56px)"};
            `}
        >
            <Spinner />
        </PageContent>
    );
};
